var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{attrs:{"target":"_blank","rel":_setup.linkRel,"href":_setup.offerUrl},on:{"!click":function($event){return _setup.onClickout($event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }